import React, {useCallback, useState, useContext, useEffect} from 'react';
import {Popup, Input, Checkbox, Button, setOptions, toast, SegmentedGroup, Segmented, Select, Textarea} from "@mobiscroll/react";
import '@mobiscroll/react/dist/css/mobiscroll.min.css';
import {NavItem, TabNav} from '@mobiscroll/react4';
import '@mobiscroll/react4/dist/css/mobiscroll.min.css';
import '../styles/dashboardHeaderInvite.css';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faXmark} from "@fortawesome/pro-duotone-svg-icons";
import Empty from "../utils/Empty";
import Loading from "../utils/Loading";
import QRCode from "react-qr-code";
import CardToken from "../utils/CardToken";
import {NetworkContext} from "../utils/NetworkContext";

setOptions({
    theme: 'ios',
    themeVariant: 'light',
});

function DashboardHeaderInvite({locale, dialog, Dialog, width}) {
    const {wsCall, wsResponse, setWsResponse} = useContext(NetworkContext);
    const [saving, setSaving] = useState(false);
    const [loading, setLoading] = useState(true);
    const [qr, setQr] = useState({});
    const [models, setModels] = useState([]);
    const [types, setTypes] = useState([]);
    const [loginTypes, setLoginTypes] = useState([]);
    const [accountName, setAccountName] = useState('cubicstone');
    const [accountDisplayName, setAccountDisplayName] = useState('');
    const [accountCustomer, setAccountCustomer] = useState('');
    const [accountTitle, setAccountTitle] = useState('');
    const [accountType, setAccountType] = useState('');
    const [trial, setTrial] = useState(false);
    const [billingTrial, setBillingTrial] = useState('1');
    const [uiLogin, setUiLogin] = useState('mobile');
    const [accountMobile, setAccountMobile] = useState(false);
    const [accountTeamtalk, setAccountTeamtalk] = useState(false);
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [type, setType] = useState('mobile');
    const [country, setCountry] = useState('us');
    const [mobile, setMobile] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState(null);
    const [confirm, setConfirm] = useState(null);
    const [uiModel, setUiModel] = useState(true);
    const [uiFunctions, setUiFunctions] = useState(true);
    const [uiOverride, setUiOverride] = useState(false);
    const [uiSystem, setUiSystem] = useState(false);
    const [accountModel, setAccountModel] = useState('');
    const [accountPrompt, setAccountPrompt] = useState('');
    const [stripe, setStripe] = useState({});
    const [cc, setCc] = useState(false);
    const [owner, setOwner] = useState(false);
    const [tab, setTab] = useState('general');
    const [coupon, setCoupon] = useState('');

    const DialogClose = useCallback(() => {
        Dialog({view: 'close'});
    }, [Dialog]);

    const Configuration = data => {
        setLoading(true);

        const message = {
            type: 'wss',
            path: 'invite-configuration',
            action: 'get',
            data: {}
        }
        wsCall(message);
    }

    const CheckPassword = () => {

        if (!password) {
            return true;
        }

        if (password.length < 8) {
            return false;
        }

        if (!/[A-Z]/.test(password)) {
            return false;
        }

        if (!/[a-z]/.test(password)) {
            return false;
        }

        if (!/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password)) {
            return false;
        }

        return true;
    }

    const SegmentedType = data => {

        setType(data.target.value);
    }

    const SelectUpdate = data => {

        setCountry(data);
    }

    const SelectLoginType = data => {
        setUiLogin(data);

        if (data !== 'multiple') {
            setType(data);
        } else {
            setType('mobile');
        }
        if (data === 'email' && accountMobile === true) {
            setAccountMobile(false);
        }
    }

    const SelectAccountType = data => {

        setAccountType(data);
    }

    const InputAccountName = data => {
        if (!data || typeof data !== 'string') {
            setAccountName('');
        }

        const lowercaseString = data.toLowerCase();

        const sanitizedString = lowercaseString.replace(/[^a-z0-9_-]/g, '');

        setAccountName(sanitizedString);
    }

    const InputCustomerName = data => {
        if (!data || typeof data !== 'string') {
            setAccountCustomer('');
        }

        const lowercaseString = data.toLowerCase();

        const sanitizedString = lowercaseString.replace(/[^a-z0-9_-]/g, '');

        setAccountCustomer(sanitizedString);
    }

    const InputBillingTrial = data => {
        if (!data) {
            setBillingTrial('');
        }

        const stringValue = String(data);
        const digitsOnly = stringValue.replace(/\D/g, '');

        setBillingTrial(digitsOnly);
    }

    const InputMobile = data => {
        let formattedText = '';

        if (country === 'us') {
            const cleanedText = data.replace(/[^\d]/g, '');

            if (cleanedText.length <= 3) {
                formattedText = cleanedText;
            } else if (cleanedText.length <= 6) {
                formattedText = `(${cleanedText.slice(0, 3)}) ${cleanedText.slice(3)}`;
            } else {
                formattedText = `(${cleanedText.slice(0, 3)}) ${cleanedText.slice(3, 6)}-${cleanedText.slice(6, 10)}`;
            }
        } else if (country === 'mx') {
            const cleanedText = data.replace(/[^\d]/g, '');

            if (cleanedText.length <= 2) {
                formattedText = cleanedText;
            } else if (cleanedText.length <= 6) {
                formattedText = `(${cleanedText.slice(0, 2)}) ${cleanedText.slice(2)}`;
            } else {
                formattedText = `(${cleanedText.slice(0, 2)}) ${cleanedText.slice(2, 6)}-${cleanedText.slice(6, 10)}`;
            }
        } else if (country === 'es') {
            const cleanedText = data.replace(/[^\d]/g, '');

            if (cleanedText.length <= 3) {
                formattedText = cleanedText;
            } else if (cleanedText.length <= 5) {
                formattedText = `${cleanedText.slice(0, 3)} ${cleanedText.slice(3)}`;
            } else if (cleanedText.length <= 7) {
                formattedText = `${cleanedText.slice(0, 3)} ${cleanedText.slice(3, 5)} ${cleanedText.slice(5)}`;
            } else {
                formattedText = `${cleanedText.slice(0, 3)} ${cleanedText.slice(3, 5)} ${cleanedText.slice(5, 7)} ${cleanedText.slice(7, 9)}`;
            }
        }

        setMobile(formattedText);
    }

    const ButtonClose = () => {
        DialogClose();
    }

    const Check = () => {
        const issues = [];

        if (!(accountName && accountDisplayName && accountTitle && accountCustomer)) {
            issues.push(locale.dashboardHeaderInvite.at);
        }
        if (accountType === 'full' && !owner &&
            ((uiLogin === 'email' && !email) ||
                (uiLogin === 'mobile' && !mobile) ||
                (uiLogin === 'multiple' && type === 'mobile' && !mobile) ||
                (uiLogin === 'multiple' && type === 'email' && !email) ||
                !(firstName && lastName && password && confirm) ||
                (password !== confirm))) {
            issues.push(locale.dashboardHeaderInvite.ax);
        }
        if (!uiModel && !accountModel) {
            issues.push(locale.dashboardHeaderInvite.n);
        }
        if (!accountPrompt) {
            issues.push(locale.dashboardHeaderInvite.bc);
        }
        if (trial && (billingTrial === '' || billingTrial === null || billingTrial === '0')) {
            issues.push(locale.dashboardHeaderInvite.au);
        }
        if (!cc && (Empty(stripe) || (!Empty(stripe) && !stripe.method))) {
            issues.push(locale.dashboardHeaderInvite.l);
        }

        if (issues.length === 0) {
            return null;
        }

        return (
            <div className="cs-dashboard-header-invite-finish">
                <ul>
                    {issues.map((issue, index) => (
                        <li key={index}>{issue}</li>
                    ))}
                </ul>
            </div>
        );
    }

    const ButtonFinish = () => {
        setSaving(true);

        const message = {
            type: 'wss',
            path: 'invite',
            action: 'put',
            data: {
                account: {
                    name: accountName,
                    customer: accountCustomer,
                    displayName: accountDisplayName,
                    title: accountTitle,
                    type: accountType,
                    mobile: accountMobile,
                    teamtalk: accountTeamtalk,
                    model: accountModel ? accountModel : null,
                    prompt: accountPrompt
                },
                billing: {
                    trial: trial ? billingTrial : null,
                    coupon: coupon ? coupon : null
                },
                stripe: stripe,
                user: !owner ? {
                    firstName: firstName ? firstName : null,
                    lastName: lastName ? lastName : null,
                    type: type,
                    country: country,
                    mobile: mobile ? mobile.replace(/[()\s-]/g, '') : null,
                    email: email ? email : null,
                    password: password ? password : null
                } : null,
                ui: {
                    header: {},
                    login: {
                        email: (uiLogin === 'multiple' || uiLogin === 'email') ? true : false,
                        forgot: true,
                        mobile: (uiLogin === 'multiple' || uiLogin === 'mobile') ? true : false,
                        multiple: uiLogin === 'multiple' ? true : false,
                        title: true,
                        username: false
                    },
                    dashboard: {
                        functions: uiFunctions,
                        model: uiModel,
                        override: uiOverride,
                        system: uiSystem
                    },
                    smartdochealth: {
                        patients: false
                    }
                }
            }
        }
        wsCall(message);
    }

    const ButtonCard = () => {
        toast({message: locale.dashboardHeaderInvite.e, color: 'danger', display: 'bottom', duration: 3000});
    }

    const GetInviteConfiguration = useCallback(data => {
        if (data.models) {
            setModels(data.models);
        }
        if (data.types) {
            setAccountType(data.types[0].value);
            setTypes(data.types);
        }
        if (data.loginTypes) {
            setUiLogin(data.loginTypes[0].value);
            setLoginTypes(data.loginTypes);
        }
        setLoading(false);
    }, []);

    const PutInvite = useCallback(data => {
        if (data.qr) {
            setQr(data.qr);
        }
        if (data.error && data.account) {
            toast({message: locale.dashboardHeaderInvite.aw, color: 'danger', display: 'bottom', duration: 3000});
        }
        if (data.error && data.stripe) {
            toast({message: locale.dashboardHeaderInvite.s, color: 'danger', display: 'bottom', duration: 3000});
        }
        setSaving(false);
    }, [locale.dashboardHeaderInvite.aw, locale.dashboardHeaderInvite.s]);

    useEffect(() => {
        if (wsResponse && wsResponse && !Empty(wsResponse) && wsResponse.action === 'put' && wsResponse.path === 'invite') {
            PutInvite(wsResponse.data);
            setWsResponse({});
        }
    }, [wsResponse, PutInvite, setWsResponse]);

    useEffect(() => {
        if (wsResponse && wsResponse && !Empty(wsResponse) && wsResponse.action === 'get' && wsResponse.path === 'invite-configuration') {
            GetInviteConfiguration(wsResponse.data);
            setWsResponse({});
        }
    }, [wsResponse, GetInviteConfiguration, setWsResponse]);

    useEffect(() => {
        Configuration();
    }, []);

    return (
        <Popup className="cs-dashboard-header-invite-popup" width={600} maxHeight={750} display="center" scrollLock={false} closeOnOverlayClick={false} closeOnEsc={false} buttons={[]} isOpen={dialog.view === 'dashboardHeaderInvite'} onClose={DialogClose}>
            <div className="mbsc-grid cs-dashboard-header-invite-header-col">
                <div className="mbsc-row cs-dashboard-header-invite-header-row">
                    {width > 576 &&
                        <div className="mbsc-col cs-dashboard-header-invite-header-col" />
                    }
                    <div className={width > 576 ? "mbsc-col cs-dashboard-header-invite-header-col mbsc-align-center" : "mbsc-col cs-dashboard-header-invite-header-col"} >
                        <Button className="cs-dashboard-header-invite-title-button mbsc-bold mbsc-txt-muted" variant="flat" >
                            {locale.dashboardHeaderInvite.ak}
                        </Button>
                    </div>
                    <div className="mbsc-col cs-dashboard-header-invite-header-col mbsc-align-right">
                        <Button color="primary" variant="flat" className="mbsc-bold cs-dashboard-header-invite-close-button" onClick={() => ButtonClose()} >
                            &nbsp;<FontAwesomeIcon className="cs-dashboard-header-invite-close-icon" icon={faXmark} />
                        </Button>
                    </div>
                </div>
            </div>
            <TabNav theme="mobiscroll" themeVariant="light" display='inline' className="cs-dashboard-header-invite-nav-tab" >
                <NavItem selected={tab === 'general'} onClick={() => tab !== 'general' && setTab('general')} >
                    <span className={tab === 'general' ? 'mbsc-bold cs-dashboard-header-invite-button-nav' : ''} >{locale.dashboardHeaderInvite.aj}</span>
                </NavItem>
                <NavItem selected={tab === 'login'} onClick={() => tab !== 'login' && setTab('login')} >
                    <span className={tab === 'login' ? 'mbsc-bold cs-dashboard-header-invite-button-nav' : ''} >{locale.dashboardHeaderInvite.y}</span>
                </NavItem>
                <NavItem selected={tab === 'ai'} onClick={() => tab !== 'ai' && setTab('ai')} >
                    <span className={tab === 'ai' ? 'mbsc-bold cs-dashboard-header-invite-button-nav' : ''} >{locale.dashboardHeaderInvite.x}</span>
                </NavItem>
                <NavItem selected={tab === 'billing'} onClick={() => tab !== 'billing' && setTab('billing')} >
                    <span className={tab === 'billing' ? 'mbsc-bold cs-dashboard-header-invite-button-nav' : ''} >{locale.dashboardHeaderInvite.w}</span>
                </NavItem>
                <NavItem selected={tab === 'qr'} onClick={() => tab !== 'qr' && setTab('qr')} >
                    <span className={tab === 'qr' ? 'mbsc-bold cs-dashboard-header-invite-button-nav' : ''} >{locale.dashboardHeaderInvite.v}</span>
                </NavItem>
            </TabNav>
            {(loading || saving) &&
                <Loading />
            }
            {!(loading || saving) && tab === 'general' &&
                <>
                    <div className="mbsc-row cs-dashboard-header-invite-helper">
                        <p>
                            {locale.dashboardHeaderInvite.aq}
                        </p>
                    </div>
                    <Input inputStyle="underline" label={locale.dashboardHeaderInvite.al} labelStyle="floating" type="text" name="accountName" value={accountName} onChange={(ev) => InputAccountName(ev.target.value)} />
                    <div className="mbsc-row cs-dashboard-header-invite-helper">
                        <p>
                            {locale.dashboardHeaderInvite.bj}
                        </p>
                    </div>
                    <Input inputStyle="underline" label={locale.dashboardHeaderInvite.bf} error={true} errorMessage={locale.dashboardHeaderInvite.bg} labelStyle="floating" type="text" name="accountCustomer" value={accountCustomer} onChange={(ev) => InputCustomerName(ev.target.value)} />
                    <Input inputStyle="underline" label={locale.dashboardHeaderInvite.am} error={true} errorMessage={locale.dashboardHeaderInvite.p} labelStyle="floating" type="text" name="accountDisplayName" value={accountDisplayName} onChange={(ev) => setAccountDisplayName(ev.target.value)} />
                    <Input inputStyle="underline" label={locale.dashboardHeaderInvite.an} error={true} errorMessage={locale.dashboardHeaderInvite.q} labelStyle="floating" type="text" name="accountTitle" value={accountTitle} onChange={(ev) => setAccountTitle(ev.target.value)} />
                    <Checkbox
                        cssClass="cs-dashboard-header-invite-checkbox mbsc-bold"
                        color="info"
                        label={locale.dashboardHeaderInvite.ab}
                        description={locale.dashboardHeaderInvite.av}
                        checked={accountTeamtalk}
                        position="start"
                        onChange={ev => setAccountTeamtalk(ev.target.checked)}
                    />
                </>
            }
            {!(loading || saving) && tab === 'login' &&
                <>
                    <Select
                        animation="slide-down"
                        dropdown={true}
                        inputStyle="underline"
                        label={locale.dashboardHeaderInvite.k}
                        labelStyle="floating"
                        rows={types.length}
                        display="anchored"
                        touchUi={false}
                        value={accountType}
                        data={types}
                        onChange={args => SelectAccountType(args.value)}
                    />
                    <Select
                        animation="slide-down"
                        dropdown={true}
                        inputStyle="underline"
                        label={locale.dashboardHeaderInvite.m}
                        labelStyle="floating"
                        rows={loginTypes.length}
                        display="anchored"
                        touchUi={false}
                        value={uiLogin}
                        data={loginTypes}
                        onChange={args => SelectLoginType(args.value)}
                    />
                    {(uiLogin === 'mobile' || uiLogin === 'multiple') &&
                        <Checkbox
                            cssClass="cs-dashboard-header-invite-checkbox mbsc-bold"
                            color="info"
                            label={locale.dashboardHeaderInvite.aa}
                            description={locale.dashboardHeaderInvite.bh}
                            checked={accountMobile}
                            position="start"
                            onChange={ev => setAccountMobile(ev.target.checked)}
                        />
                    }
                    {(accountType === 'full' || accountType === 'smartdochealth') &&
                        <Checkbox
                            cssClass="cs-dashboard-header-invite-checkbox mbsc-bold"
                            color="info"
                            label={locale.dashboardHeaderInvite.ah}
                            description={locale.dashboardHeaderInvite.z}
                            checked={owner}
                            position="start"
                            onChange={ev => setOwner(ev.target.checked)}
                        />
                    }
                    {(accountType === 'full' || accountType === 'smartdochealth') && !owner &&
                        <div className="mbsc-form-group">
                            {uiLogin === 'multiple' &&
                                <div className="mbsc-grid cs-dashboard-header-invite-header-col">
                                    <div className="mbsc-row cs-dashboard-header-invite-header-row">
                                        <SegmentedGroup className="cs-dashboard-header-invite-nav" name="type" color="primary" value={type} onChange={SegmentedType}>
                                            <Segmented value="email" >
                                                {locale.dashboardHeaderInvite.d}
                                            </Segmented>
                                            <Segmented value="mobile" >
                                                {locale.dashboardHeaderInvite.f}
                                            </Segmented>
                                        </SegmentedGroup>
                                    </div>
                                </div>
                            }
                            {((uiLogin === 'mobile') || (uiLogin === 'multiple' && type === 'mobile')) &&
                                <div className="mbsc-grid cs-dashboard-header-invite-header-col">
                                    <div className="mbsc-row cs-dashboard-header-invite-header-row">
                                        <div className="mbsc-col-4 cs-dashboard-header-invite-inputs-left">
                                            <Select
                                                animation="slide-down"
                                                dropdown={false}
                                                inputStyle="underline"
                                                label={locale.dashboardHeaderInvite.t}
                                                labelStyle="floating"
                                                rows={locale.dashboardHeaderInvite.u.length}
                                                display="anchored"
                                                touchUi={false}
                                                value={country}
                                                data={locale.dashboardHeaderInvite.u}
                                                disabled={mobile}
                                                onChange={args => SelectUpdate(args.value)}
                                            />
                                        </div>
                                        <div className="mbsc-col-8 cs-dashboard-header-invite-inputs-right">
                                            <Input
                                                endIcon="line-key"
                                                className="cs-dashboard-header-invite-inputs-right-input"
                                                label={locale.dashboardHeaderInvite.f}
                                                inputStyle="underline"
                                                labelStyle="floating"
                                                type="text"
                                                name="mobile"
                                                value={mobile}
                                                onChange={ev => InputMobile(ev.target.value)}
                                            />
                                        </div>
                                    </div>
                                </div>
                            }
                            {((uiLogin === 'email') || (uiLogin === 'multiple' && type === 'email')) &&
                                <Input endIcon="line-key" inputStyle="underline" label={locale.dashboardHeaderInvite.d} labelStyle="floating" type="text" name="email" value={email} onChange={ev => setEmail(ev.target.value)} />
                            }
                            <Input inputStyle="underline" label={locale.dashboardHeaderInvite.a} labelStyle="floating" type="text" name="firstName" value={firstName} onChange={ev => setFirstName(ev.target.value)}/>
                            <Input inputStyle="underline" label={locale.dashboardHeaderInvite.b} labelStyle="floating" type="text" name="lastName" value={lastName} onChange={ev => setLastName(ev.target.value)}/>
                            <Input error={!CheckPassword()} errorMessage={locale.dashboardHeaderInvite.ar} inputStyle="underline" label={locale.dashboardHeaderInvite.h} labelStyle="floating" type="password" name="password" passwordToggle={true} value={password} onChange={(ev) => setPassword(ev.target.value)} />
                            <Input error={confirm && password !== confirm} errorMessage={locale.dashboardHeaderInvite.ap} inputStyle="underline" label={locale.dashboardHeaderInvite.i} labelStyle="floating" type="password" name="confirm" passwordToggle={true} value={confirm} onChange={(ev) => setConfirm(ev.target.value)} />
                        </div>
                    }
                </>
            }
            {!(loading || saving) && tab === 'ai' &&
                <>
                    <Checkbox
                        cssClass="cs-dashboard-header-invite-checkbox mbsc-bold"
                        color="info"
                        label={locale.dashboardHeaderInvite.ae}
                        description={locale.dashboardHeaderInvite.ba}
                        checked={uiOverride}
                        position="start"
                        onChange={ev => setUiOverride(ev.target.checked)}
                    />
                    <Checkbox
                        cssClass="cs-dashboard-header-invite-checkbox mbsc-bold"
                        color="info"
                        label={locale.dashboardHeaderInvite.ac}
                        description={locale.dashboardHeaderInvite.ay}
                        checked={uiModel}
                        position="start"
                        onChange={ev => setUiModel(ev.target.checked)}
                    />
                    {!uiModel &&
                        <Select
                            animation="slide-down"
                            dropdown={true}
                            inputStyle="underline"
                            label={locale.dashboardHeaderInvite.ag}
                            labelStyle="floating"
                            rows={models.length}
                            display="anchored"
                            touchUi={false}
                            value={accountModel}
                            data={models}
                            onChange={args => setAccountModel(args.value)}
                        />
                    }
                    <Checkbox
                        cssClass="cs-dashboard-header-invite-checkbox mbsc-bold"
                        color="info"
                        label={locale.dashboardHeaderInvite.ad}
                        description={locale.dashboardHeaderInvite.az}
                        checked={uiFunctions}
                        position="start"
                        onChange={ev => setUiFunctions(ev.target.checked)}
                    />
                    <Checkbox
                        cssClass="cs-dashboard-header-invite-checkbox mbsc-bold"
                        color="info"
                        label={locale.dashboardHeaderInvite.af}
                        description={locale.dashboardHeaderInvite.bb}
                        checked={uiSystem}
                        position="start"
                        onChange={ev => setUiSystem(ev.target.checked)}
                    />
                    <div className="cs-dashboard-header-invite-textarea">
                        <Textarea
                            label={locale.dashboardHeaderInvite.bd}
                            inputStyle="underline"
                            labelStyle="floating"
                            rows={3}
                            value={accountPrompt}
                            onChange={(ev) => setAccountPrompt(ev.target.value)}
                        />
                    </div>
                </>
            }
            {!(loading || saving) && tab === 'billing' &&
                <>
                    <Checkbox
                        cssClass="cs-dashboard-header-invite-checkbox mbsc-bold"
                        color="info"
                        label={locale.dashboardHeaderInvite.c}
                        description={locale.dashboardHeaderInvite.bi}
                        checked={trial}
                        position="start"
                        onChange={ev => setTrial(ev.target.checked)}
                    />
                    {trial &&
                        <Input inputStyle="underline" label={locale.dashboardHeaderInvite.ao} labelStyle="floating" type="text" name="billingTrial" value={billingTrial} onChange={(ev) => InputBillingTrial(ev.target.value)} />
                    }
                    <Checkbox
                        cssClass="cs-dashboard-header-invite-checkbox mbsc-bold"
                        color="info"
                        label={locale.dashboardHeaderInvite.be}
                        description={locale.dashboardHeaderInvite.bk}
                        checked={cc}
                        position="start"
                        onChange={ev => setCc(ev.target.checked)}
                    />
                    <Input inputStyle="underline" label={locale.dashboardHeaderInvite.j} labelStyle="floating" type="text" name="coupon" value={coupon} onChange={(ev) => setCoupon(ev.target.value)} />
                    {!cc &&
                        <>
                            <div className="cs-dashboard-header-invite-card">
                                <CardToken
                                    textNext={locale.dashboardHeaderInvite.ai}
                                    Next={ButtonCard}
                                    textBack={null}
                                    Back={null}
                                    setStripe={setStripe}
                                />
                            </div>
                        </>
                    }
                </>
            }
            {!(loading || saving) && tab === 'qr' &&
                <>
                    {Check() &&
                        <div className="cs-dashboard-header-invite-finish">
                            <p>
                                {locale.dashboardHeaderInvite.o}
                            </p>
                        </div>
                    }
                    {Check()}
                    {!Check() && Empty(qr) &&
                        <div className="mbsc-align-center cs-dashboard-header-invite-finish">
                            <p>
                                {locale.dashboardHeaderInvite.bm}
                            </p>
                        </div>
                    }
                    {!Check() && Empty(qr) &&
                        <div className="mbsc-align-center cs-dashboard-header-invite-finish">
                            <p>
                                {locale.dashboardHeaderInvite.bl}
                            </p>
                        </div>
                    }
                    {!Check() && Empty(qr) &&
                        <div className="mbsc-align-center cs-dashboard-header-invite-finish-end">
                            <p>
                                {locale.dashboardHeaderInvite.as}
                            </p>
                        </div>
                    }
                    {!Check() && !Empty(qr) && qr.url &&
                        <div className="mbsc-grid">
                            <div className="mbsc-row mbsc-justify-content-center cs-dashboard-header-invite-qr">
                                <QRCode
                                    size={256}
                                    value={qr.url}
                                    viewBox={`0 0 256 256`}
                                />
                            </div>
                        </div>
                    }
                    {!Check() && !Empty(qr) && qr.url &&
                        <div className="mbsc-row mbsc-justify-content-center cs-dashboard-header-invite-helper-qr">
                            <p>
                                <a href={qr.url} target="_blank" className="cs-dashboard-header-invite-links">{qr.url}</a>
                            </p>
                        </div>
                    }
                    <div className="mbsc-button-group-justified cs-dashboard-header-invite-nav-buttons">
                        <Button disabled={Check() && !Empty(qr)} color="primary" variant="flat" className="mbsc-bold cs-dashboard-header-invite-button" onClick={() => ButtonFinish()} >
                            {locale.dashboardHeaderInvite.r}
                        </Button>
                    </div>
                </>
            }
        </Popup>
    );
}

export default DashboardHeaderInvite;
